import React, {Component} from 'react';
import { getLetzfairAuthData } from "../../helpers";

class LetsFair extends Component {

    interval = null;
    tries = 0;

    componentDidMount() {
        // console.log('[LETZFAIR] Init')
        this.loadAPI();
    }

    componentDidUpdate(prevProps) {
        // Carica i dati auth quando l'utente si logga
        if (!prevProps.user && this.props.user) {
            this.loadAuthData();
        }
    }

    /**
     * window.letzfair= window.letzfair || function(){(letzfair.q=letzfair.q||[]).push(arguments)};letzfair.l=+new Date;
     letzfair('key_test');

     */

    async loadAuthData() {
        try {
            const letzfairAuthData = await getLetzfairAuthData();
            if (window._letzfair) {
                this.loadApiCallback(letzfairAuthData);
            }
        } catch (error) {
            console.error('[LETZFAIR] Error loading auth data:', error);
        }
    }

    async loadAPI() {

        // console.log('loadAPI');

        const scriptExists = document.getElementById('letsfair-api');
        if (!scriptExists) {

            try {
                const script = document.createElement('script')
                script.id = 'letsfair-api';
                script.src = this.props.jsUrl
                document.body.append(script);

                this.interval = setInterval(async () => {
                    if (this.tries > 10) {
                        clearInterval(this.interval);
                    }
                    if (window.letzfair) {
                        clearInterval(this.interval);
                        window._letzfair.api_key = this.props.apiKey;
                        // Carica i dati auth solo se l'utente è loggato
                        if (this.props.user) {
                            await this.loadAuthData();
                        }
                    }
                }, 500)

                // console.log('[LETZFAIR] Lib loaded')
            } catch (error) {
                console.error('[LETZFAIR] Error loading script:', error);
            }
        }


    }

    loadApiCallback(letzfairAuthData) {

        window._letzfair.timestamp = letzfairAuthData.timestamp;
        window._letzfair.check_api_key = letzfairAuthData.checkString;
        window.letzfair();

    }

    render() {

        return <div/>

    }

}

export default LetsFair;
